import * as types from "../types/triggers.types";

const initialState = {
  initialData: [],
  initialLoading: false,
  initialPagination: [],
  initialFilter: {
    page: 1,
    limit: 10,
    search: '',
  },
};

const TriggersReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_LIST_DATA:
      return { ...state, initialData: action.payload };
    case types.SET_LOADING_DATA:
      return { ...state, initialLoading: action.payload };
    case types.SET_LIST_PAGINATION:
      return { ...state, initialPagination: action.payload };
    case types.SET_LIST_FILTER:
      return { ...state, initialFilter: action.payload };
    case types.RESET_REDUCER:
      return {
        ...state,
        initialData: [],
        initialLoading: false,
        initialPagination: [],
        initialFilter: initialState.initialFilter,
      };
    default:
      return state;
  }
};
export default TriggersReducer;
